export const cateringProcess = [
    {
        title: 'Share your plans',
        text: 'Tell us about your occasion, date, guest numbers and the dishes you love, through our booking form or on WhatsApp.'
    },
    {
        title: 'Get a tailored menu',
        text: 'We suggest a menu that fits your guests, your style and your budget, then send you a clear quote.'
    },
    {
        title: 'Confirm your booking',
        text: 'Once you are happy with the menu and the quote, we lock in your date and prepare every detail.'
    },
    {
        title: 'We cook, deliver and serve',
        text: 'Your food is freshly prepared, beautifully presented and delivered on time, so you can enjoy the moment.'
    }
]

export const diasporaSteps = [
    {
        title: 'Choose Your Food or Package',
        text: 'Pick a meal, a surprise tray or a special package from our menu, or ask us for something custom.'
    },
    {
        title: 'Tell Us Where To Deliver',
        text: 'Share your loved one’s name, phone number and delivery address in Nigeria, and the day it should arrive.'
    },
    {
        title: 'Make Payment From Anywhere',
        text: 'Choose Naira, US Dollars or British Pounds. We confirm your order and total with you before we start cooking.'
    }
]
